import { useMenu } from "../context/MenuContext";

export function useModuleAccess(moduleId?: number | string, isReportMode: boolean = false) {
    const { menuSettings } = useMenu();

    const numericId = moduleId ? Number(moduleId) : undefined;

    if (!numericId) {
        return {
            canRead: true,
            canCreate: true,
            canEdit: true,
            canDelete: true,
        }; 
    }

    const moduleAccess = isReportMode ? {access: '*'} : menuSettings.modules?.find(m => m.id === numericId);
    const raw = (moduleAccess?.access || "").toLowerCase().trim();

    if (!raw) {
        return { canRead: false, canCreate: false, canEdit: false, canDelete: false };
    }

    if (raw === "*") {
        return { canRead: true, canCreate: true, canEdit: true, canDelete: true };
    }

    return {
        canRead: raw.includes("r"),
        canCreate: raw.includes("c"),
        canEdit: raw.includes("w"),
        canDelete: raw.includes("d"),
    };
}
